function dispatchFrame(frame, onMessage) {
  const lines = String(frame || "").split(/\r?\n/);
  const data = [];
  let lastEventId = "";
  for (const line of lines) {
    if (!line || line.startsWith(":")) continue;
    const separator = line.indexOf(":");
    const field = separator >= 0 ? line.slice(0, separator) : line;
    let value = separator >= 0 ? line.slice(separator + 1) : "";
    if (value.startsWith(" ")) value = value.slice(1);
    if (field === "data") data.push(value);
    if (field === "id") lastEventId = value;
  }
  if (!data.length) return;
  onMessage({ data: data.join("\n"), lastEventId });
}

export function createSseParser(onMessage) {
  let buffer = "";
  return {
    push(chunk) {
      buffer += String(chunk || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
      let boundary = buffer.indexOf("\n\n");
      while (boundary >= 0) {
        dispatchFrame(buffer.slice(0, boundary), onMessage);
        buffer = buffer.slice(boundary + 2);
        boundary = buffer.indexOf("\n\n");
      }
    },
    finish() {
      if (buffer.trim()) dispatchFrame(buffer, onMessage);
      buffer = "";
    },
  };
}

export function createAuthenticatedEventStream(url, token) {
  const controller = new AbortController();
  let closed = false;
  const stream = {
    onmessage: null,
    onerror: null,
    close() {
      if (closed) return;
      closed = true;
      controller.abort();
    },
  };

  Promise.resolve().then(async () => {
    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
        credentials: "include",
        headers: {
          Accept: "text/event-stream",
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      });
      if (!response.ok || !response.body) {
        const error = new Error(`SSE bağlantısı kurulamadı (${response.status}).`);
        error.status = response.status;
        if (!response.ok) {
          try {
            const payload = await response.json();
            error.code = payload?.code || null;
            error.payload = payload;
            if (payload?.message) error.message = payload.message;
          } catch (_) {}
        }
        throw error;
      }

      const parser = createSseParser((event) => stream.onmessage?.(event));
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      while (!closed) {
        const { done, value } = await reader.read();
        if (done) break;
        parser.push(decoder.decode(value, { stream: true }));
      }
      parser.push(decoder.decode());
      parser.finish();
      if (!closed) stream.onerror?.(new Error("SSE bağlantısı kapandı."));
    } catch (error) {
      if (!closed && error?.name !== "AbortError") stream.onerror?.(error);
    }
  });

  return stream;
}
